module.exports = __webpack_public_path__ + "static/media/Lets_start_button.43bc1d51.mp3";